import $, { css, get } from "jquery";
import noUiSlider from "nouislider";
$(function () {
// Opening a mobile filter
$("#mobileFilter").on("click", function () {
  $("#filterMenu").addClass("open");
  $("body").css("overflow", "hidden");

  //show the background
  if (!$(".filter-overlay").length) {
    $("body").append('<div class="filter-overlay"></div>');
  }
  $(".filter-overlay").fadeIn(200);
});

// Filter closure
function closeFilterMenu() {
  $("#filterMenu").removeClass("open");
  $("body").css("overflow", "");

  $(".filter-overlay").fadeOut(200, function () {
    $(this).remove();
  });
}

$(".close-filter-menu").on("click", closeFilterMenu);

//click out of menu -closure
$(document).on("click", ".filter-overlay", closeFilterMenu);

// Opening submenu (departure from left to right)
$(".filter-list li").on("click", function () {
  var target = $(this).data("target");
  if (target) {
    $("#mainMenu").animate({ left: "100%" }, 200, function () {
      $(this).hide();
      $("#" + target)
        .css("left", "-100%")
        .show()
        .animate({ left: "0" }, 200);
    });
  }
});

// Return to the main menu (departure to the right)
$(".backToMain").on("click", function () {
  var submenu = $(this).closest(".submenu");
  submenu.animate({ left: "-100%" }, 200, function () {
    submenu.hide();
    $("#mainMenu")
      .css("left", "100%")
      .show()
      .animate({ left: "0" }, 200);
  });
});

});
